import { FC, useRef, useEffect, useState } from "react";
import { PaperClipIcon, XIcon, PlusIcon, DownloadIcon } from "@heroicons/react/outline";

const MultipleDocumentInLineWithAddingNew: FC<{ doc_info: any, name: string, files: any, setFiles: any, exsitingFiles: Array<any> }> = ({ doc_info, name, files, setFiles, exsitingFiles }) => {
    const inputRef = useRef<HTMLInputElement | null>(null);
    const storageRef = useRef<HTMLInputElement | null>(null);

    const handleUploadClick = () => {
        inputRef.current?.click();
    }

    let uploadedFiles = exsitingFiles || []

    const [formData, setFormData] = useState({files: new Array<any>()})

    const handleUploadFile = (elem: any) => {
        console.log(elem.target.files);
        let temp = Array<any>()
        for (var i = 0; i < elem.target.files.length; i++) {
            temp.push(elem.target.files[i])
        }
        setFormData({files: [...formData.files, ...temp]})
    }

    const removeFile = (id: number) => {
        console.log(id)
        let temp = formData.files
        temp.splice(id, 1)
        setFormData({files: temp})
    }

    useEffect(() => {
        setFiles(formData.files)
    }, [formData])

    return (
        <div>
            <div className="flex flex-row text-base items-end justify-start">
                <div className="font-medium">{name}</div>
                <button className="ml-3 text-blue-600" onClick={handleUploadClick}>
                    {"Добавить"}
                {/* <PlusIcon className="h-4 w-4"></PlusIcon> */}
                </button>
            </div>
            <input type="file" multiple ref={inputRef} className="hidden absolute" onChange={e => handleUploadFile(e)} />
            <input type="file" multiple ref={storageRef} className="hidden absolute" />
            <div className="flex flex-col mt-1">
                {
                    uploadedFiles.length != 0 ? uploadedFiles.map((elem: any, index) => {
                        console.log(elem)
                        return (
                            <div key={`File ${elem.split("/").at(-1)} ${index-1}`} className="bg-white border rounded text-base pl-2 pr-4 py-1 mt-1 flex flex-row justify-between items-center">
                                <div className="flex flex-row items-center font-medium">
                                    <PaperClipIcon className="h-5 pr-2 text-blue-500"></PaperClipIcon>
                                    {elem.split("/").at(-1)}
                                </div>
                                <a href={`https://elabfactor.com/api/deliveries/downloadFile.php?token=${localStorage.getItem('access_token')}&file=${encodeURIComponent(elem)}`}>
                                    <DownloadIcon onClick={() => {removeFile(index)}} className="h-5 text-black/60 hover:text-black cursor-pointer"></DownloadIcon>
                                </a>
                            </div>
                        )
                    }) : <></>
                }
                {
                    formData.files.map((elem: any, index) => {
                        return (
                            <div key={`File ${elem.name} ${index-1}`} className="bg-white border rounded text-base pl-2 pr-4 py-1 mt-1 flex flex-row justify-between items-center">
                                <div className="flex flex-row items-center font-medium">
                                    <PaperClipIcon className="h-5 pr-2 text-blue-500"></PaperClipIcon>
                                    {elem.name}
                                </div>
                                <div>
                                    <XIcon onClick={() => {removeFile(index)}} className="h-5 text-black/60 hover:text-black cursor-pointer"></XIcon>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default MultipleDocumentInLineWithAddingNew